if (!customElements.get('show-more-content')) {
  class ShowMoreContent extends HTMLElement {
    constructor() {
      super();
  
      this.controllButton = this.querySelector('.show-more-btn-toogle');
      this.content = this.querySelector('.show-more-content');
      this.readMoreButton = this.querySelector('.read_less');
      this.readLessButton = this.querySelector('.read_less');
      this.noScroll = this.getAttribute('data-no-scroll') === 'true';
  
      if (!this.controllButton || !this.content || !this.readMoreButton || !this.readLessButton) {
        return;
      }
  
      this.init();
    }
  
    init() {
      this.controllButton.addEventListener('click', (event) => {
        this.content.classList.toggle('is-collapsed');
  
        const buttonAtribute = this.controllButton.getAttribute('aria-expanded');
  
        if (buttonAtribute === 'true') {
          if (!this.noScroll) {
            this.content.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
  
          this.readMoreButton.setAttribute('aria-hidden', 'false');
          this.readLessButton.setAttribute('aria-hidden', 'true');
  
          return this.controllButton.setAttribute('aria-expanded', 'false');
        }
        
        this.readMoreButton.setAttribute('aria-hidden', 'true');
        this.readLessButton.setAttribute('aria-hidden', 'false');
        this.controllButton.setAttribute('aria-expanded', 'true');
      });
    }

    controlShowButton(maxHeight) {
      const contentHeight = this.content.clientHeight
      const checkMaxHeight = maxHeight || 2000;

      if (contentHeight >= checkMaxHeight) {
        return;
      }

      this.controllButton.style.display = 'none';
      this.content.classList.remove('is-collapsed');
      this.readMoreButton.setAttribute('aria-hidden', 'true');
      this.readLessButton.setAttribute('aria-hidden', 'true');
    }
  }
  
  customElements.define('show-more-content', ShowMoreContent);
}